import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useJetStatusContextValue } from '../context/JetStatusProvider'

export const JetStatusHeader = () => {
  const { state, actions } = useJetStatusContextValue()

  return (
    <Header
      title="Jet Call Report Sync Status"
      rightContent={
        <QueryStatus
          dataUpdatedAt={state.dataUpdatedAt}
          isFetching={state.isFetching}
          refetch={actions.refetch}
          isError={state.isError}
          error={state.error}
        />
      }
    />
  )
}
